// extracted by mini-css-extract-plugin
export var copyableField = "_l2-4";
export var customerBadge = "_l2-0";
export var customerInfoTitle = "_l2-2";
export var details = "_l2-1";
export var dropdownContainer = "_l2-5";
export var dropdownImage = "_l2-6";
export var editAssigneeForm = "_l2-a";
export var editButton = "_l2-3";
export var email = "_l2-7";
export var hidden = "_l2-d";
export var input = "_l2-8";
export var saveButton = "_l2-b";
export var shopifyIcon = "_l2-c";
export var suggestionBadge = "_l2-e";
export var suggestionText = "_l2-f";
export var username = "_l2-9";